import Vue from 'vue';

const setDeep = (obj, paths, value) => {
  const path = paths.shift();
  if (!obj[path]) {
    Vue.set(obj, path, {});
  }

  if (!paths.length) {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      Vue.set(obj, path, {
        ...obj[path],
        ...value,
      });
    } else {
      Vue.set(obj, path, value);
    }

    return;
  }

  setDeep(obj[path], paths, value);
};

export default setDeep;
